/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_MY_FILES_REQUEST]: state => {
    state.loadingMyFiles = true;
    state.loadMyFilesFailed = false;
    state.loadMyFilesSuccess = false;
  },
  [types.GET_MY_FILES_FAILURE]: (state, error) => {
    state.loadingMyFiles = false;
    state.loadMyFilesFailed = true;
    state.loadMyFilesError = error;
  },
  [types.GET_MY_FILES_SUCCESS]: (state, response) => {
    state.loadingMyFiles = false;
    state.loadMyFilesSuccess = true;
    state.myFiles.push(...response.data.results);
    state.myFilesPage += 1;
  },

  [types.GET_COMPANY_FILES_REQUEST]: state => {
    state.loadingCompanyFiles = true;
    state.loadCompanyFilesFailed = false;
    state.loadCompanyFilesSuccess = false;
  },
  [types.GET_COMPANY_FILES_FAILURE]: (state, error) => {
    state.loadingCompanyFiles = false;
    state.loadCompanyFilesFailed = true;
    state.loadCompanyFilesError = error;
  },
  [types.GET_COMPANY_FILES_SUCCESS]: (state, response) => {
    state.loadingCompanyFiles = false;
    state.loadCompanyFilesSuccess = true;
    state.companyFiles.push(...response.data.results);
    state.companyFilesPage += 1;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filebox/mutations.js